import { Text } from '@/ui/primitives';
import { formatTextValue } from '../formatters/infoFieldUtils';
import { Stack } from '../layout/Stack';
import type { SpacingToken } from '@/theme/tokens';
import type { ReactElement, ReactNode } from 'react';

type InfoFieldProps = {
  label: string;
  value?: ReactNode;
  align?: 'left' | 'right';
  gap?: SpacingToken;
};

const resolveDisplayValue = (value: ReactNode | undefined): ReactNode => {
  if (value === null || value === undefined) return '-';
  if (typeof value === 'string') return formatTextValue(value);
  if (typeof value === 'number') return String(value);
  return value;
};

export const InfoField = ({
  label,
  value,
  align = 'left',
  gap = 'sm',
}: InfoFieldProps): ReactElement => {
  const displayValue = resolveDisplayValue(value);
  return (
    <Stack gap={gap}>
      <Text role="label" color="textSecondary" align={align}>
        {label}
      </Text>
      <Text
        role="body"
        align={align}
        component="div"
        sx={{
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
        }}
      >
        {displayValue}
      </Text>
    </Stack>
  );
};
